import React from 'react';
import { isTextButtonProps } from '../../utils/is-button-props';
import { IconButton, IconButtonProps } from '../icon-button';
import { TextButton, TextButtonProps } from '../text-button';

export type ButtonProps = TextButtonProps | IconButtonProps;

export const Button: React.FC<ButtonProps> = (props) => {
  if (isTextButtonProps(props)) {
    return <TextButton {...props} />;
  }
  return <IconButton {...props} />;
};
